import React from 'react';
import { TriptychLayout } from '../../components/layout/TriptychLayout';
import EnrollmentExplanation from './components/EnrollmentExplanation';
import EnrollmentCheckList from './components/EnrollmentCheckList';
import VanTrustContactInfo from './components/VanTrustContactInfo';
import ContactForm from './components/ContactForm';

const HomePage = () => (
  <TriptychLayout>
    <EnrollmentExplanation />
    <ContactForm />
    <>
      <EnrollmentCheckList />
      <VanTrustContactInfo />
    </>
  </TriptychLayout>
);

export default HomePage;
